import {Card} from "../../../../../../components/card/card.jsx";
import SentryRow from "../../../../../../components/template/sentry-row.jsx";
import SelectComponent from "../../../../../../components/select/select-component.jsx";
import {CAMERAS_SETUP} from "../../../utils/lanes-utils.js";
import OnePositionCameraForm from "./one-position-camera-form.jsx";
import {useFormContext} from "react-hook-form";
import FormField from "../../../../../../components/react-hook-form/form-field.jsx";
import {useMemo, useState} from "react";
import {createBasicSetup, ftpSetupOptions} from "../../../utils/lanes-form-utils.js";
import InputForm from "../../../../../../components/input/input-form.jsx";

const Camera = ({ftpUsers}) => {
  const {setValue, watch} = useFormContext();
  const [blockedDriver, setBlockedDriver] = useState(null);
  const mobile = watch("capturePlace.mobile");
  const setup = watch("smartcaptureDriver.setup");

  const CAMERAS_RULES = useMemo(() => {
    if(mobile) return CAMERAS_SETUP.filter(el => !el.disableOnMobile);

    return CAMERAS_SETUP
  }, [mobile])

  return(
    <Card className="h-full">
      <Card.Body>
        <SentryRow>
         <FormField
          name="smartcaptureDriver.setup"
          customRender={field => (
            <SelectComponent
              instanceId="smartcaptureDriverSetupForm"
              id="smartcaptureDriverSetupForm"
              label="Tipo de instalação *"
              options={CAMERAS_RULES}
              value={field.value}
              onChange={selected => {
                setValue("smartcaptureDriver.back", createBasicSetup());
                setValue("smartcaptureDriver.forward", createBasicSetup());
                setValue("forwardBackFirstSelected", null);
                field.onChange(selected?.value ?? "");
              }}
              classNameWrapper="col-span-6"
            />
          )}
         />
          <div className="col-span-6"></div>
          { setup && (setup === "back" || setup === "forward") &&
            <div className="col-span-6">
              <OnePositionCameraForm/>
            </div>
          }
          { setup && setup === "forwardback" &&
            <>
              <div className="col-span-6">
                <Card>
                  <Card.Header>
                    <Card.Title>
                      Câmera dianteira
                    </Card.Title>
                  </Card.Header>
                  <Card.Body>
                    <OnePositionCameraForm rule="forward"/>
                  </Card.Body>
                </Card>
              </div>
              <div className="col-span-6">
                <Card>
                  <Card.Header>
                    <Card.Title>
                      Câmera traseira
                    </Card.Title>
                  </Card.Header>
                  <Card.Body>
                    <OnePositionCameraForm rule="back"/>
                  </Card.Body>
                </Card>
              </div>
            </>
          }
          { setup && setup === "ftp" &&
            <SentryRow className="col-span-6">
              <FormField
                name="smartcaptureDriver.ftpSetup"
                customRender={field => (
                  <SelectComponent
                    id="ftpSetupForm"
                    label="Setup *"
                    instanceId="ftpSetupForm"
                    value={ftpSetupOptions.find(el => el.value === field.value)}
                    options={ftpSetupOptions}
                    isDisabled={true}
                    classNameWrapper="col-span-12"
                  />
                )}
              />
              <FormField
                name="smartcaptureDriver.model_details.account"
                customRender={field => (
                  <SelectComponent
                    id="smartcaptureDriverFtpAccoutForm"
                    instanceId="smartcaptureDriverFtpAccoutForm"
                    label="Usuário FTP *"
                    value={ftpUsers.find(el => el.value === field.value)}
                    options={ftpUsers}
                    isDisabled={true}
                    classNameWrapper="col-span-6"
                  />
                )}
              />
              <FormField
                name="smartcaptureDriver.model_details.id"
                as={InputForm}
                id="smartcaptureDriverFtpIdForm"
                label="Identificador de câmera"
                disabled={true}
                classNameWrapper="col-span-6"
              />
            </SentryRow>
          }
        </SentryRow>
      </Card.Body>
    </Card>
  )
}

export default Camera;